// extracted by mini-css-extract-plugin
export var breadcrumb = "_13-2";
export var breadcrumbArrow = "_13-3";
export var breadcrumbs = "_13-0";
export var link = "_13-4";
export var small = "_13-1";